import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="product-grid"
export default class extends Controller {

  /**
   * Toggles the map view on and off by adding/removing
   * the 'data-map-view-active="true"' attribute from the controller's element.
   */
  toggle(event) {
    console.log('clicked')
    event.preventDefault()

    // Check if the attribute exists
    const isActive = this.element.hasAttribute("data-map-view-active")

    if (isActive) {
      this.element.removeAttribute("data-map-view-active")
    } else {
      this.element.setAttribute("data-map-view-active", "true")
    }
  }

  /**
   * Handles a click on a product item.
   */
  select(event) {
    // 1. Check if map view is active.
    const isActive = this.element.hasAttribute("data-map-view-active")

    // If it's NOT active, do nothing and let the link work normally.
    if (!isActive) {
      return // Allows the default link navigation
    }

    // 2. If map view IS active, stop the link from navigating.
    event.preventDefault()

    // 3. Turn off map view by removing the attribute.
    this.element.removeAttribute("data-map-view-active")

    // 4. Scroll the page to the item that was just clicked.
    event.currentTarget.scrollIntoView({
      behavior: "smooth",
      block: "nearest"
    })
  }
}
